import React from "react";

import { mdiClose, mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";

type Props = {
  value: string;
  placeholder?: string;
  disabled?: boolean;
  onChangeText: (text: string) => void;
  onClear: () => void;
};

export default function SearchInput({
  value,
  placeholder = "Buscar producto",
  disabled,
  onChangeText,
  onClear,
}: Props) {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-gray-400">
        <Icon path={mdiMagnify} size={0.85} />
      </div>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChangeText(e.target.value)}
        className="block appearance-none rounded-md w-full border border-solid border-white-500 bg-white-100 py-3 pl-10 pr-10 leading-tight text-base font-sans text-gray-900 placeholder-gray-400 focus:outline-none box-border"
        disabled={disabled}
      />
      {value && (
        <button
          type="button"
          onClick={onClear}
          className="absolute right-0 top-0 bottom-0 px-3 text-gray-400 bg-transparent border-none cursor-pointer flex items-center"
        >
          <Icon path={mdiClose} size={0.85} />
        </button>
      )}
    </div>
  );
}
